import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // window.scrollTo(0, 0);
    document.getElementById("scrollTop").scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }, [pathname]);

  return null;
}



// WEBPACK FOOTER //
// ./src/ScrollToTop.js